import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';

import * as _ from 'lodash';

const windDirectionDegrees = new Map<string, number>()
  .set('N', 0)
  .set('NNE', 23)
  .set('NE', 45)
  .set('ENE', 68)
  .set('E', 90)
  .set('ESE', 113)
  .set('SE', 135)
  .set('SSE', 158)
  .set('S', 180)
  .set('SSW', 203)
  .set('SW', 225)
  .set('WSW', 248)
  .set('W', 270)
  .set('WNW', 293)
  .set('NW', 315)
  .set('NNW', 338);

@Pipe({
  name: 'contentTemperature'
})
export class TemperaturePipe implements PipeTransform {

  transform(entry: Models.ContentEntry): Models.PeakTemperatureEntry[] {
    const peaks: Models.PeakTemperatureEntry[] = [];

    if (!entry || !entry.detail || !entry.detail.peaks) {
      return null;
    }

    for (const rawPeak of entry.detail.peaks) {

      const peakData = {
        sourceId: entry._id,
        location: rawPeak.place,
        windDirection: rawPeak.windDir,
        windDirectionDegrees: windDirectionDegrees.get(rawPeak.windDir) || 0,
        heightAboveSeaLevel: !_.isNaN(rawPeak.height) ? parseFloat(rawPeak.height) : 0,
        temperature: !_.isNaN(rawPeak.temperature) ? parseFloat(rawPeak.temperature) : 0,
        windSpeed: !_.isNaN(rawPeak.windSpeed) ? parseFloat(rawPeak.windSpeed) : 0
      };

      const peak = new Models.PeakTemperatureEntry();

      peak.populateFromJSON(peakData);

      peaks.push(peak);
    }

    if (peaks.length === 0) {
      return null;
    }

    return peaks;
  }

}
